import { Palette } from "lucide-react";

const COLOR_PRESETS = [
  { name: "Champagne Gold", value: "#C5A880" },
  { name: "Rose Gold", value: "#D99A86" },
  { name: "Emerald", value: "#2E9C7F" },
  { name: "Royal Blue", value: "#4A6FDC" },
  { name: "Plum", value: "#9B5FA8" },
  { name: "Graphite", value: "#8A8F9B" },
];

export default function ColorSection({ form, patch }) {
  return (
    <div>
      <label className="label-luxe flex items-center gap-1.5">
        <Palette size={11} /> Primary colour
      </label>
      <div className="flex items-center gap-3">
        <input
          type="color"
          value={form.primary_color}
          onChange={(e) => patch("primary_color", e.target.value.toUpperCase())}
          className="w-14 h-11 rounded-lg bg-transparent border border-white/10 cursor-pointer p-1"
          data-testid="branding-color-picker"
          aria-label="Primary colour picker"
        />
        <input
          className="input-luxe uppercase tracking-widest"
          value={form.primary_color}
          onChange={(e) => patch("primary_color", e.target.value.toUpperCase())}
          placeholder="#C5A880"
          maxLength={7}
          data-testid="branding-color-hex-input"
        />
      </div>
      <div className="grid grid-cols-6 gap-2 mt-3">
        {COLOR_PRESETS.map((p) => {
          const selected = p.value.toUpperCase() === form.primary_color.toUpperCase();
          return (
            <button
              key={p.value}
              onClick={() => patch("primary_color", p.value.toUpperCase())}
              className="w-full aspect-square rounded-lg transition transform hover:scale-105"
              style={{
                background: p.value,
                outline: selected ? `2px solid ${p.value}` : "none",
                outlineOffset: selected ? "2px" : undefined,
                boxShadow: selected ? `0 0 0 1px rgba(255,255,255,0.15)` : "none",
              }}
              title={p.name}
              data-testid={`branding-color-preset-${p.value.replace("#", "").toLowerCase()}`}
              aria-label={`Use ${p.name}`}
            />
          );
        })}
      </div>
      <p className="text-[11px] text-white/40 mt-2">
        Used for brand text, primary buttons, input focus and PDF accents.
      </p>
    </div>
  );
}
